import React, { SetStateAction } from 'react';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import { RecipePresetSubstep, settingsInterface } from '../../../app/recipeCreation/createRecipe.types';
import useLogRecipeEdit from '../../../hooks/useLogRecipeEdit';
import { EventLogsEnum } from '../../../utils/events';
import styles from './presetsConfirmDialog.module.css';

const PresetsConfirmDialog = (
    {
        confirmPopUpOpen,
        setConfirmPopUpOpen,
        setIsPresetOpen,
        settings,
        setSettings,
        setPresetSelected,
        presetSettings,
        presetSelected
    }: {
        confirmPopUpOpen: boolean,
        setConfirmPopUpOpen: React.Dispatch<SetStateAction<boolean>>,
        setIsPresetOpen: React.Dispatch<SetStateAction<boolean>>,
        settings: Array<settingsInterface>,
        setSettings: React.Dispatch<SetStateAction<Array<settingsInterface>>>,
        setPresetSelected: React.Dispatch<SetStateAction<RecipePresetSubstep | null>>,
        presetSettings: Array<settingsInterface>,
        presetSelected: RecipePresetSubstep | null;
    }) => {
    
    const { logRecipeEdit } = useLogRecipeEdit();
    
    const handleClose = () => {
        setConfirmPopUpOpen(false);
    };
    
    const handleContinueButton = () => {
        const subStepId = presetSelected?.subStepId;
        logRecipeEdit(EventLogsEnum.APP_PRESET_EDIT, {
            eventData: { subStepId }
        });
        setSettings(presetSettings);
        setPresetSelected(null);
        setIsPresetOpen(false);
        setConfirmPopUpOpen(false);
    };

    return (
        <Dialog
            onClose={handleClose}
            open={confirmPopUpOpen}
            PaperProps={{ className: styles.dialog_paper }}
        >
            <Grid>
                <DialogContent className={styles.dialog_content}>
                    <Typography variant='caption3Light'>
                        Editing will remove the preset.
                        Still want to continue?
                    </Typography>
                </DialogContent>
                <DialogActions className={styles.dialog_actions}>
                    <Button className={styles.cancel_button} onClick={handleClose}>
                        <Typography variant='caption3Light'>Cancel</Typography>
                    </Button>
                    <Button autoFocus className={styles.continue_button} onClick={handleContinueButton}>
                        <Typography variant='caption3Light'>Continue</Typography>
                    </Button>
                </DialogActions>
            </Grid>
        </Dialog>
    );
};

export default PresetsConfirmDialog;
